var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timer", {
    attrs: {
      role: "timer",
      color: _vm.color,
      time: _vm.duration - (_vm.ghost ? _vm.ghost : _vm.playtime),
      "aria-label": _vm.$t(_vm.a11y.key, _vm.a11y.attr),
      tabindex: "0",
      remaining: true,
      "data-test": "timer-duration"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }